//export const _razor_key = "rzp_test_IF84ihZodLqUUJ"
export const _razor_key = "rzp_live_Nx7UWc62ezlvZJ"
export const xapikeys = "as03-d032dsf4353424";